/** @format */
import { useEffect, useState } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
export function useLocalStorage(key: string, initialValue: any) {
    /*
     * State to store our value
     * Pass initial state function to useState so logic is only executed once
     */
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    const [storedValue, setStoredValue] = useState(initialValue);

    /**
     * Return a wrapped version of useState's setter function that
     * persists the new value to localStorage.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
    const setValue = (value: any) => {
        // Allow value to be a function so we have same API as useState
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
        const valueToStore =
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call -- Legacy code: do not use as an example.
            value instanceof Function ? value(storedValue) : value;
        // Save state
        setStoredValue(valueToStore);
        // Save to local storage
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
    };

    useEffect(() => {
        try {
            // Get from local storage by key
            const item = window.localStorage.getItem(key);
            if (item) {
                // Parse stored json or if none return initialValue
                setStoredValue(JSON.parse(item));
            }
        } catch (error) {
            console.error(error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- Legacy code: do not use as an example.
    }, []);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
    return [storedValue, setValue];
}
